import axios from 'axios';

/**
 * 获取团险字典
 */
function getGroupDic() {
  return axios.get(`apply/v1/group/input/dictionaries?`)
}

export default {
  getGroupDic
};



// WEBPACK FOOTER //
// ./src/interface.js